import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../ui/Badge';
import Button from '../ui/Button';
import styles from './QuoteTable.module.css';

const statusToneMap = {
  'Awaiting Market Data': 'warning',
  'Estimate Ready': 'success',
  'Requires Review': 'danger'
};

const QuoteTable = ({ quotes }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Quote ID</th>
            <th>Status</th>
            <th>Lane</th>
            <th>Mode</th>
            <th>Equipment</th>
            <th>Pickup</th>
            <th>Delivery</th>
            <th>Rate</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {quotes.map((quote) => (
            <tr key={quote.id}>
              <td>
                <span className={styles.primaryCell}>{quote.id}</span>
                <span className={styles.secondaryCell}>Created {quote.createdOn}</span>
              </td>
              <td>
                <Badge tone={statusToneMap[quote.status] || 'neutral'}>{quote.status}</Badge>
              </td>
              <td>
                <span className={styles.primaryCell}>{quote.lane}</span>
                <span className={styles.secondaryCell}>{quote.stops} stops</span>
              </td>
              <td>{quote.mode}</td>
              <td>{quote.equipment}</td>
              <td>
                <div className={styles.dateStack}>
                  <span className={styles.primaryCell}>{quote.pickupDate}</span>
                  <span className={styles.secondaryCell}>Pickup</span>
                </div>
              </td>
              <td>
                <div className={styles.dateStack}>
                  <span className={styles.primaryCell}>{quote.deliveryDate}</span>
                  <span className={styles.secondaryCell}>Delivery</span>
                </div>
              </td>
              <td>{quote.rateEstimate || 'Pending'}</td>
              <td className={styles.ctaCell}>
                <Button variant="quiet" size="sm">Cancel</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {quotes.length === 0 && (
        <div className={styles.emptyState}>
          <h4>No quotes yet</h4>
          <p>Create your first quote to start building market intelligence.</p>
        </div>
      )}
    </div>
  );
};

QuoteTable.propTypes = {
  quotes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      lane: PropTypes.string.isRequired,
      mode: PropTypes.string.isRequired,
      equipment: PropTypes.string.isRequired,
      pickupDate: PropTypes.string.isRequired,
      deliveryDate: PropTypes.string.isRequired,
      rateEstimate: PropTypes.string,
      stops: PropTypes.number
    })
  ).isRequired
};

export default QuoteTable;
